module.exports = __webpack_public_path__ + "img/alert.0016a9ba.svg";